import { render } from "./BannerPageComponent.vue?vue&type=template&id=8b282ee2"
import script from "./BannerPageComponent.vue?vue&type=script&lang=js"
export * from "./BannerPageComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__